module.exports = __webpack_public_path__ + "static/img/img-main-features-setcion-1-m@3x.99ea923.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-features-setcion-1-m@3x.png
// module id = 13x/
// module chunks = 18